export default "__VITE_ASSET__5b01f264__"